/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import axios from "axios/dist/axios.min.js";
import utils from "../../utils/utils";
import px2rem from '../../utils/px2rem';
import { Exposure } from 'shihuo-lib/dist/shihuo-lib';
import "./style.less";
import { LazyLoadImage } from "react-lazy-load-image-component";
import 'react-lazy-load-image-component/src/effects/opacity.css';

class PipelineSearchProduct extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
    };
    this.screenRatio = 1;
    this.exp = new Exposure(); // 曝光
    if (typeof window !== 'undefined') {
      this.screenRatio = document.body.clientWidth / 375;
    }
  }

  componentDidMount() {
    this.getProductListData();
  }

  getProductListData() {
    const itemList = this.props.config.itemList;
    const itemDataObj = {};
    const idList = itemList.map((item) => {
      if (item.id) {
        itemDataObj[item.id] = item;
      }
      return isNaN(Number(item.id)) ? 0 : Number(item.id);
    });

    let reqUrl = "";
    const productType = this.props.config.baseConfig.productType;
    if (productType === "商品id") {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";
    } else if (productType === "配色id") {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";
    } else if (productType === "skuId") {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/sku/info?access_token=znSnA7pxO35wtPBaur";
    }

    axios({
      url: reqUrl,
      method: "post",
      withCredentials: true,
      data: {
        ids: idList,
        sort_tag: 0,
        filter_subsidy: 0,
        from: this.props.specialApiFrom
      },
    }).then((res) => {
      if (res.data.status === 0) {
        const list = res.data.data.List;
        list.forEach(product => {
          const customItem = itemList.find && itemList.find((item) => item.id == product.id);
          if (customItem) {
            product.custom_title = customItem.name;
          }
        });
        this.setState({
          list,
        });
      }
    });
  }

  handleItemClick = (item, index) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.url,
        props: this.props,
        index
      })
      return
    }
    if (!item.url) {
      // 空白不跳转
      return;
    }
    const baseConfig = this.props.config.baseConfig;
    const options = {
      url: item.url,
      type: baseConfig.sortType,
      sort: index,
      name: item.title
    };

    const convertUrl = utils.convertHref(item.url);
    utils.jumpToUrl(this.props.routeParams,convertUrl,item.url, options, -1,this.props,false);

  }

  handleViewAll = () => {
    const viewAllLink = this.props.config.baseConfig.viewAllLink;
    if (!viewAllLink) {
      return;
    }
    const options = {
      link: viewAllLink,
    };

    const convertUrl = utils.convertHref(viewAllLink);
    utils.jumpToUrl(this.props.routeParams,convertUrl,viewAllLink, options, -1,this.props,false, {
      id: 'legoSearchCard:watch_more',
      name: 'pipeline-searchProduct',
      from: 'lego_search_card',
      block: 'watch_more',
      tpName: this.props.searchWords,
    });
  }

  renderCard = ({ item, index, scroll, isLast }) => {
    const imgSize = scroll ? px2rem('90px', false) : px2rem('103px', false);
    return (
      <div className="card-item"
        onClick={this.handleItemClick.bind(this, item, index)}
        data-dot={JSON.stringify({
          id: 'legoSearchCard:card',
          name: 'pipeline-searchProduct',
          href: '',//跳转的 href, 非必传
          exposekey: 'card',//必传
          pti_refer: {
            // pageId: this.pageId,
            root: {
              // pageId: this.pageId,
              biz: ''
            },
            parent: {},
          },
        })}              
        ref={ele => {
          if (ele) {
            this.exp.add({ el: ele });
          }
        }} 
        style={{
          marginRight: isLast ? 0 : px2rem('8px', false),
        }}
      >
        <div className="img-container" style={{ width: imgSize, height: imgSize }}>
          <LazyLoadImage
            className="img"
            src={utils.formatImgUrl(item.image, this.props.webpSupport)}
            effect="opacity"
          />
          {/* <img className="img" src={utils.formatImgUrl(item.image, this.props.webpSupport)} alt="" /> */}
        </div>
        <React.Fragment>
          <div className="name" style={{ width: imgSize, height: px2rem('17px', false), marginTop: px2rem('4px', false), marginBottom: px2rem('0px', false), fontSize: px2rem('12px', false), lineHeight: px2rem('17px', false) }}>{item.custom_title || item.title}</div>
          <div className="price" style={{ height: px2rem('18px', false) }}>
            {
              item.price && (
                <Fragment>
                  <div className="rmb-icon" style={{ fontSize: px2rem('11px', false) }}>￥</div>
                  <div className="rmb-num" style={{ fontSize: px2rem('16px', false) }}>{item.price}</div>
                </Fragment>
              )
            }
          </div>
        </React.Fragment>
      </div>
    )
  }

  render() {
    const { baseConfig, itemList } = this.props.config;
    const list = this.state.list.length ? this.state.list : itemList;
    const scroll = Boolean(list.length > 3);

    const Card = this.renderCard;
    const cardListElement = list.map((item, index) => <Card item={item} scroll={scroll} key={item.id} index={index} isLast={index === (list.length - 1)} />);
    return (
      <div
        className="pipeline-search-product"
        id={this.props['customAttributes']['data-component-id']}
        name={baseConfig.title}
        {...this.props['customAttributes']}
        style={{
          marginTop: px2rem('8px', false),
          marginBottom: px2rem('10px', false),
        }}
      >
        {scroll ?
          (
            <div className="card-list scroll-card-list">
              <div style={{ paddingLeft: px2rem('12px', false), height: 10 }}></div>
              {cardListElement}
              <div
                className="all-btn"
                onClick={this.handleViewAll}
                style={{ height: px2rem('90px', false), marginLeft: px2rem('8px', false) }}
                data-dot={JSON.stringify({
                  id: 'legoSearchCard:watch_more',
                  name: 'pipeline-searchProduct',
                  href: '',//跳转的 href, 非必传
                  exposekey: 'watch_more',//必传
                  pti_refer: {
                    // pageId: this.pageId,
                    root: {
                      // pageId: this.pageId,
                      biz: ''
                    },
                    parent: {},
                  },
                })}              
                ref={ele => {
                  if (ele) {
                    this.exp.add({ el: ele });
                  }
                }}              
              >
                <img className="all-img" src={utils.formatImgUrl('https://static.shihuocdn.cn/admin/files/20211014/ffc32c3ae5754a3b5983eb245f2cd4da.png', this.props.webpSupport)} alt="all" style={{ width: px2rem('30px', false), marginLeft: px2rem('17px', false), marginRight: px2rem('17px', false), marginTop: px2rem('28px', false), marginBottom: px2rem('6px', false) }} />
                <div style={{ fontSize: px2rem('11px', false), color: '#333', textAlign: 'center' }}>查看全部</div>
              </div>
              <div style={{ paddingLeft: px2rem('12px', false), height: 10 }}></div>
            </div>
          ) :
          (
            <div className="card-list" style={{ marginLeft: px2rem('12px', false), marginRight: px2rem('12px', false) }}>
              {cardListElement}
            </div>
          )
        }
      </div>
    );
  }
}

PipelineSearchProduct.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineSearchProduct };
export default PipelineSearchProduct;



// WEBPACK FOOTER //
// ./components/pipeline-searchProduct/index.js